/**
 * 访问资源国际化
 * date：2022 03 07
 */
export default {
    resource:{
        in:'在',
        menu:'菜单',
        menuMsg:'菜单信息',
        name:'名称',
        nameZh:'中文名称',
        nameEn:'英文名称',
        nameZhNotEmpty:'中文名称不能为空',
        nameEnNotEmpty:'英文名称不能为空',
        code:'编号',
        enable:'启用',
        visualRole:'可视角色',
        peerMenu:'同级菜单',
        subMenu:'子级菜单',
        add:'新增',
        refresh:'刷新',
        intry:'入口',
        func:'功能',
        funcCode:'功能码',
        optare:'操作',
        confirm:'确认' ,
        edit:'编辑',
        cancel:'取消',
        delete:'删除',
        funcCodeNotEmtry:'功能码不能为空',
        noData:'暂无数据',
        icon:'图标',
        iconNot:'图标不符合',
        fillManuaiiy:'手动填写',
        nameNotEmpty:'名称不能为空',
        codeNotEmpty:'编号不能为空',
        iconNotEmpty:'图标不能为空',
        yes:'是',
        no:'否',
        allVisible:'所有可见',
        adminVisible:'管理员类型可见',
        systemVisible:'系统范围可见',
        extraCode:"附加码",

        // V8: 弹出框（FunctionDialog）相关
        functionDetail:'功能详情',
        addFunction:'新增功能',
        editFunction:'编辑功能',
        urlList:'URL 列表',
        url:'URL',
        method:'Method',
        pathParam:'路径参数',
        addUrl:'添加 URL',
        removeUrl:'移除',
        selectUrl:'选择 URL',
        urlNotEmpty:'URL 不能为空',
        urlAlreadyExists:'该 URL 已添加',
        urlCount:'URL 数量',
        selectUrlPlaceholder:'请选择要关联的 URL',
        noUrlSelected:'暂未添加 URL',

        code_407:"名称已存在",
        code_408:"编码已存在",
        drag_sort_tip:'拖拽菜单节点可调整排序',
        sort_saved:'排序已保存',
        sort_save_failed:'排序保存失败，已恢复',
    }
}